import { ColumnChartProcessor } from "./Core";

export class SingleEntityColumnChartProcessor extends ColumnChartProcessor {
  public identity = "SingleEntityColumnChartProcessor";
}
